@if (uptkdetaileddata | async; as item) {
  <div>
    @if (item?.uid=='SeqirusUptakeAcceleratorDetailMainComp1' && screenvalue==1 ) {
      <div class="container uptk_MainContainer"
        >
        <div class="uptk_Main_Header">{{item?.materialSubHeading}}</div>
        <div class="uptk_Step_One">
          <div class="uptk_Num_Line"><span class="uptk_Sno">1</span>
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_text">
          <div [innerHtml]="item?.LargeText1"></div>
          <div class="Upt_iconbox">
            <div class="ladyicon"><img [src]="getImage(item?.UptakeImg3)" [alt]="item?.UptakeImg3.code" ></div>
            <div class="thirdicontext normalfirsttext" [innerHtml]="item?.itemPerPack">
            </div>
          </div>
        </div>
      </div>
      <div class="uptk_Download_Container">
        <div class="uptk_Num_Line">
          <div class="uptk_vertical_Line"></div>
        </div>
        <!-- Resources download section-->
        <div class="row uptk_Download_Row pb16">
          <div class="col-md-6 uptk_Dwnld_Txt">
            <div [innerHTML]="item?.h2content"></div>
            <a [href]="getpdf(item?.media)" class="uptk_Download_Btn acuptake_btn">{{item?.urlLink}}</a>
          </div>
          <div class="col-md-6">
            <img [src]="getImage(item?.UptakeImg4)" [alt]="item?.UptakeImg4.code" class="uptk_Img">
          </div>
        </div>
      </div>
      <!-- second point-->
      <div class="uptk_Step_Two" [innerHTML]="item?.LargeText2"></div>
      <!--Third point-->
      <div class="uptk_Step_Three" [innerHTML]="item?.LargeText3"></div>
      <!--Image and text section-->
      <div class="img_Txt_Container">
        <div class="uptk_Num_Line">
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="img_Txt_Row firstimagetip row">
          <div class="col-md-1 uptake_Img_Row ">
            <img [src]="getImage(item?.UptakeImg2)" [alt]="item?.UptakeImg2.code" class="uptk_txt_Row_Img">
          </div>
          <div class="col-md-11 uptk_Txt_Row icontext " [innerHtml]="item?.text1">
          </div>
        </div>
      </div>
      <div class="uptk_Tooltip_Box">
        <div class="uptk_Num_Line">
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_tip_section row" [innerHtml]="item?.text2"></div>
      </div>
      <!-- Resources Download Section-->
      <div class="uptk_Download_Container">
        <div class="uptk_Num_Line">
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="row uptk_Download_Row">
          <div class="col-md-6">
            <img [src]="getImage(item?.picture2)" [alt]="item?.picture2.code" class="uptk_Img">
          </div>
          <div class="col-md-6 uptk_Dwnld_Txt">
            <div [innerHTML]="item?.h2content"></div>
            <a  [href]="getpdf(item?.media)" class="uptk_Download_Btn acuptake_btn">{{item?.urlLink}}</a>
          </div>
        </div>
      </div>
      <!--Fourth point-->
      <div class="uptk_Step_Four" [innerHTML]="item?.largeparagraphcontent"></div>
      <div class="img_Txt_Container">
        <div class="uptk_Num_Line uptk_Step_Four_NumLine firstline">
          <div class="uptk_vertical_Line"></div>
          <div class="uptk_horizontal_line"></div>
        </div>
        <div class="img_Txt_Row row">
          <div class="col-md-1 uptake_Img_Row pt16 pb16">
            <img [src]="getImage(item?.UptakeImg3)" [alt]="item?.UptakeImg3.code" class="uptk_txt_Row_Img">
          </div>
          <div class="col-md-11 pt16 pb16 uptk_Txt_Row icontext iconfourth" [innerHtml]="item?.text3">
          </div>
          <div class="redtip" [innerHtml]="item?.materialCode"></div>
        </div>
      </div>
    </div>
  }
  <!-- second page section -->
  @if (item?.uid=='SeqirusUptakeAcceleratorDetailMainComp2' && screenvalue==2) {
    <div class="container uptk_MainContainer no-padding-top"
      >
      <div class="uptk_Main_Header">{{item?.materialSubHeading}}</div>
      <div class="initialimg"><img [src]="getImage(item?.UptakeImg1)"></div>
      <div class="uptk_Step_One">
        <div class="uptk_Num_Line">
          <span class="uptk_Sno">1</span>
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_text">
          <div [innerHtml]="item?.content"></div>
          <div class="Upt_iconbox">
            <div class="ladyicon"><img [src]="getImage(item?.UptakeImg3)" [alt]="item?.UptakeImg3.code">
            </div>
            <div class="icontext" [innerHtml]="item?.text3">
            </div>
          </div>
        </div>
      </div>
      <!-- second point-->
      <div class="uptk_Step_Two">
        <div class="uptk_Num_Line">
          <span class="uptk_Sno">2</span>
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_text">
          <div [innerHtml]="item?.largeparagraphcontent"></div>
          <div class="Upt_iconbox">
            <div class="ladyicon"><img [src]="getImage(item?.UptakeImg4)" [alt]="item?.UptakeImg4.code">
            </div>
            <div class="icontext" [innerHtml]="item?.solutiontype"></div>
          </div>
        </div>
      </div>
      <div class="uptk_Step_Three">
        <div class="uptk_Num_Line">
          <span class="uptk_Sno">3</span>
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_text">
          <div [innerHtml]="item?.headline"></div>
          <div class="upt_imgcont">
            <div class="uptcont1">
              <div class="Upt_secondtext" [innerHtml]="item?.itemPerPack">
              </div>
              <a [href]="item?.h3content" class="uptk_Download_Btn acuptake_btn">{{item?.urlLink}}</a>
            </div>
            <div class="upt_imageshow">
              <img [src]="getImage(item?.UptakeImg2)" [alt]="item?.UptakeImg2.code" class="uptk_Img">
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="uptk_Step_Four">
          <div class="uptk_Num_Line"><span class="uptk_Sno">4</span>
          <div class="uptk_vertical_Line"></div>
        </div>
        <div class="uptk_Text" [innerHtml]="item?.text1">
        </div>
      </div>
      <div class="img_Txt_Container">
        <div class="uptk_Num_Line uptk_Step_Four_NumLine secondnumberline">
          <div class="uptk_vertical_Line"></div>
          <div class="uptk_horizontal_line"></div>
        </div>
        <div class="uptk_Text op_last">
          <div class="Upt_iconbox">
            <div class="ladyicon"> <img [src]="getImage(item?.UptakeImg3)" [alt]="item?.UptakeImg3.code"></div>
            <div class="icontext iconfourth" [innerHtml]="item?.text2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- third page -->
@if (item?.uid=='SeqirusUptakeAcceleratorDetailMainComp3' && screenvalue==3) {
  <div class="container uptk_MainContainer no-padding-top"
    >
    <div [innerHtml]="item?.text1"></div>
    <div class="stepmainimage">
      <img [src]="getImage(item?.UptakeImg2)" [alt]="item?.UptakeImg2.code">
    </div>
    <div class="uptk_Step_One">
      <div class="uptk_Num_Line">
        <span class="uptk_Sno">1</span>
        <div class="uptk_vertical_Line"></div>
      </div>
      <div class="uptk_text" [innerHtml]="item?.text2">
      </div>
    </div>
    <!-- second point-->
    <div class="uptk_Step_Two">
      <div class="uptk_Num_Line">
        <span class="uptk_Sno">2</span>
        <div class="uptk_vertical_Line"></div>
      </div>
      <div class="uptk_text">
        <div [innerHtml]="item?.text3"></div>
        <div class="Upt_iconbox">
          <div class="ladyicon"> <img [src]="getImage(item?.UptakeImg3)" [alt]="item?.UptakeImg3.code"></div>
          <div class="icontext thirdicontext" [innerHtml]="item?.headline">
          </div>
        </div>
      </div>
    </div>
    <div class="uptk_Step_Three">
      <div class="uptk_Num_Line">
        <span class="uptk_Sno">3</span>
        <div class="uptk_vertical_Line"></div>
      </div>
      <div class="uptk_text" [innerHtml]="item?.text4">
      </div>
    </div>
    <div class="img_Txt_Container">
      <div class="uptk_Num_Line uptk_Step_Four_NumLine thirdline">
        <div class="uptk_vertical_Line"></div>
        <div class="uptk_horizontal_line"></div>
      </div>
      <div class="Upt_iconbox"></div>
    </div>
  </div>
}
</div>
}